import * as React from "react"
const Settings = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#202327"
      stroke="#202327"
      strokeWidth={1.5}
      d="M17.5 10a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0ZM11.25 10a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0ZM5 10a1.25 1.25 0 1 0-2.5 0A1.25 1.25 0 0 0 5 10Z"
    />
  </svg>
)
export default Settings
